import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Container, ButtonVisitShowroom, ButtonExplore } from './footer.styled.component'
// import { useResize } from '../../../../hooks'

export const FooterComponent = ({ onClickExploreAllProducts, onClickVisitShowroom }) => {

  // const isMobile = useResize().isMobile

  return (
    <Container>
        <ButtonExplore onClick={onClickExploreAllProducts} >
         <span><FormattedMessage id="explore-all-products" /></span>
        </ButtonExplore>
        <ButtonVisitShowroom onClick={onClickVisitShowroom}>
            <span><FormattedMessage id="visit-showroom" /></span>
        </ButtonVisitShowroom>
    </Container>
  )
};
